<template>
 <div class="">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="年月:">
          <el-date-picker
            v-model="searchFrom.month"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            :clearable="false"
            placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamName" filterable placeholder="请选择" clearable @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-select v-model="searchFrom.driverName" filterable placeholder="请选择">
            <el-option v-for="item in sijiList" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" border size="mini" style="width: 100%" height="100%" center class="tableComent">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="100"></el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" min-width="120"></el-table-column>
        <el-table-column prop="teamName" label="所属小队" min-width="100" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="haulVolume" label="运量(吨)" min-width="100"></el-table-column>
        <el-table-column prop="haulVolumePiece" label="运量(件)" min-width="100"></el-table-column>
        <el-table-column prop="freightPayable" label="运费(元)" min-width="110" sortable :sort-method="sortByNumber('freightPayable')"></el-table-column>
        <el-table-column prop="oilDeduct" label="加油款扣除(元)" min-width="140" sortable :sort-method="sortByNumber('oilDeduct')"></el-table-column>
        <el-table-column prop="gasDeduct" label="加气款扣除(元)" min-width="140" sortable :sort-method="sortByNumber('gasDeduct')"></el-table-column>
        <el-table-column prop="tollDeduct" label="路桥费扣除(元)" min-width="140" sortable :sort-method="sortByNumber('tollDeduct')"></el-table-column>
        <el-table-column prop="bonus" label="奖金(元)" min-width="110" sortable :sort-method="sortByNumber('bonus')"></el-table-column>
        <el-table-column prop="penalty" label="罚金(元)" min-width="110" sortable :sort-method="sortByNumber('penalty')"></el-table-column>
        <el-table-column prop="subsidy" label="司机补助(元)" min-width="130" sortable :sort-method="sortByNumber('subsidy')"></el-table-column>
        <el-table-column prop="tripFee" label="应付趟费(元)" min-width="130" sortable :sort-method="sortByNumber('tripFee')"></el-table-column>
        <!-- 社保代扣：包含养老、失业、医疗、合计 -->
        <el-table-column label="社保代扣(元)">
          <el-table-column prop="pensionDeduct" label="养老代扣" min-width="110" sortable :sort-method="sortByNumber('pensionDeduct')"></el-table-column>
          <el-table-column prop="unemploymentDeduct" label="失业代扣" min-width="110" sortable :sort-method="sortByNumber('unemploymentDeduct')"></el-table-column>
          <el-table-column prop="medicalDeduct" label="医疗代扣" min-width="110" sortable :sort-method="sortByNumber('medicalDeduct')"></el-table-column>
          <el-table-column prop="totalDeductions" label="合计代扣" min-width="110" sortable :sort-method="sortByNumber('totalDeductions')"></el-table-column>
        </el-table-column>
        <el-table-column prop="netPay" label="实发工资(元)" min-width="130" sortable :sort-method="sortByNumber('netPay')"></el-table-column>
        <el-table-column prop="platformAmount" label="付平台金额(元)" min-width="150" sortable :sort-method="sortByNumber('platformAmount')"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <!-- <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { driverPayrollSummaryDetail } from '@/api/newTMS'
import { organizationTree, cDlists } from '@/api/vgs-driver2.0'
export default {
  props: {
    detailId: {
      type: [String, Number],
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      emptyFn: emptyFn,
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        month: ''
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      XDList: [],
      sijiList: [],
      btnFlg: [],
      btnIdArr: ['01N02H0100', '01N02H0200'],
      currentMasterId: null
    }
  },
  // 添加 watch 监听 detailId 的变化
  watch: {
    detailId: {
      handler (newVal) {
        if (newVal) {
          this.currentMasterId = newVal
          // 清空年月参数
          delete this.searchFrom.month
          this.getList()
        }
      },
      immediate: true
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    if (!this.detailId) {
    // 没有 detailId 时，设置默认年月
      this.searchFrom.month = this.getNextMonth()
      this.searchFn()
    }
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 176) + 'px'
  },
  methods: {
    getNextMonth () {
      const date = new Date()
      date.setMonth(date.getMonth() - 1)

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')

      return `${year}-${month}`
    },
    // 获取列表
    getList () {
      this.loading = true
      let params = { ...this.searchFrom }

      // 如果有 currentMasterId，传 masterId
      if (this.currentMasterId) {
        params.summaryId = this.currentMasterId
        delete params.month // 有 masterId 时不传年月
      } else {
        // 没有 masterId 时，传年月参数
        // if (this.searchFrom.month) {
        //   let strMonth = this.searchFrom.month.split('-')
        //   params.year = Number(strMonth[0])
        //   params.month = Number(strMonth[1])
        // }
        // delete params.month
        delete params.summaryId
      }

      driverPayrollSummaryDetail(params).then(res => {
        this.tableList = res.list || res // 根据接口返回结构调整
        this.total = res.total || this.tableList.length
        this.sum = res.map || {}
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err.message)
      })
    },
    carChange (e) {
      if (e) {
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.name == e)
        this.sijiList = []
        // this.$set(this.searchFrom, 'driverId', '')
        this.$set(this.searchFrom, 'driverName', '')
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
      }
    },
    // 导出
    exportFn () {
      let params = { ...this.searchFrom }
      // 如果有 currentMasterId，传 masterId
      if (this.currentMasterId) {
        params.summaryId = this.currentMasterId
        delete params.month // 有 masterId 时不传年月
      } else {
        delete params.summaryId
      }
      delete params.pageNo
      delete params.pageSize
      exportExcel(
        this.global.tmsPlus + '/driverPayrollSummary/exportDetail',
        params,
        '司机薪资列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (!this.currentMasterId && !this.searchFrom.month) {
        this.searchFrom.month = this.getNextMonth()
      }
      this.getList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      if (this.currentMasterId) {
        // 有 masterId 时，重置后重新加载详情
        this.getList()
      } else {
        // 没有 masterId 时，设置默认年月后查询
        this.searchFrom.month = this.getNextMonth()
        this.searchFn()
      }
    },
    sortByNumber (prop) {
      return (a, b) => this.toNumber(a[prop]) - this.toNumber(b[prop])
    },
    toNumber (value) {
      if (value === null || value === undefined || value === '') return 0

      const number = Number(String(value).replace(/,/g, ''))
      return Number.isNaN(number) ? 0 : number
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
